module.exports = __webpack_public_path__ + "img/hostal-de-la-luz-regalo.cfcc50ba.jpg";